import { createContext, useContext } from "react";

/**
 * True inside a zusammengelegte Seite (#630): the hub shows the page title and
 * the tabs, so the page inside leaves out its own heading.
 */
export const HubContext = createContext(false);

export function useInHub(): boolean {
  return useContext(HubContext);
}
